import React from "react";

/**
 * Ctrl(Cmd)+Enterキーでの送信処理を行うカスタムフック
 * @param onSubmit - 送信時に実行するコールバック関数
 * @returns TextAreaのKeyboardEventハンドラー
 */
export const useSubmitOnCtrlEnter = (
  onSubmit: () => void,
): React.KeyboardEventHandler<HTMLTextAreaElement> => {
  return React.useMemo(
    () => (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "Enter") {
        e.preventDefault();
        onSubmit();
      }
    },
    [onSubmit],
  );
};
